define('sortable/sortable.mixin',[
  'underscore',
  'marionette',
  './sortable'
], function(
  _,
  Mn,
  Sortable
) {

  var SortableMixin = {

    initializeSortable: function() {
      var options = _.extend({}, Mn._getValue(this.getOption('sortableOptions'), this), {
        isDraggable: _.bind(this.isDraggable, this),
        isDragHandle: _.bind(this.isDragHandle, this),
        isDroppable: _.bind(this.isDroppable, this)
      });

      this.sortable = new Sortable(this, options)
      this
          .listenTo(this.sortable, 'placeholder:index', this.onPlaceholderChangeIndex)
          .listenTo(this.sortable, 'drag:end', this.onDragEnd)
    },

    isDraggable: function() { return true; },
    isDragHandle: function() { return true; },
    isDroppable: function() { return true; },
    onPlaceholderChangeIndex: function(placeholder, index) {},
    onDragEnd: function() {}

  };

  return SortableMixin;
});
